import { useSyncExternalStore } from "react";

/**
 * Is there a network, honestly (SPEC §8.3).
 *
 * `navigator.onLine` is famously optimistic — it says "yes" on a Wi-Fi with no
 * route out. It is used here only to *stop* trying, never to promise a child
 * that something was sent: what is on screen after a submission comes from the
 * queue's own state, not from this.
 */
function subscribe(callback: () => void): () => void {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}
